import React, { useRef, useState, useEffect } from 'react'
import CanvasThumbnail from './CanvasThumbnail'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import { Button } from 'carbon-components-react'
import { CaretLeft, CaretRight } from '@carbon/icons-react'
import { ThemesProperties } from '../CanvasConstants/ThemesProperties'
import LayoutTitle from './LayoutsList/LayoutTitle'
import LayoutVideoDesc from './LayoutsList/LayoutVideoDesc'
import LayoutQA from './LayoutsList/LayoutQA'
import LayoutQ_2_A from './LayoutsList/LayoutQ_2_A'
import LayoutHeadDesc from './LayoutsList/LayoutHeadDesc'
import LayoutImageHeading from './LayoutsList/LayoutImageHeading'
import LayoutQ_3_A from './LayoutsList/LayoutQ_3_A'
import LayoutImageAssmnt from './LayoutsList/LayoutImageAssmnt'

function TemplatesList(props) {
  const {
    activityDataFromParent,
    currentSelectedPage,
    onTempSideMenuChange,
    templateItemClick
  } = props
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen((isOpen) => !isOpen)
  }

  useEffect(() => {
    onTempSideMenuChange(isOpen)
  }, [isOpen])

  return (
    <div className='temp-side-menu-cont'>
      <div className={isOpen ? 'temp-list' : 'temp-list hide-div'}>
        {activityDataFromParent.OtherActivities.map((templateData, index) => {
          //get current template data
          const curretnActivityJson = JSON.parse(templateData.ActivityJson)
          const { TemplateSettings, InputRows, ReplayRectangles } =
            curretnActivityJson
          //find current template theme
          let propertiesIndex = ThemesProperties.findIndex(
            (obj) => obj.themeName === TemplateSettings.themeName
          )
          let currentThemePropertiesCopy = {}
          if (propertiesIndex > -1) {
            currentThemePropertiesCopy = ThemesProperties[propertiesIndex]
          } else {
            currentThemePropertiesCopy = ThemesProperties[0]
          }
          //find current theme is light/dark
          let currentThemeProperties = TemplateSettings.isLight
            ? currentThemePropertiesCopy.themeLight
            : currentThemePropertiesCopy.themeDark
          let currentThemeData = currentThemeProperties
          let pageNumber = index + 1
          return (
            <div
              key={'tempList' + index}
              className={
                index === currentSelectedPage
                  ? 'thumb-main-cont thumb-selected'
                  : 'thumb-main-cont '
              }
              onClick={() => {
                if (index !== currentSelectedPage) {
                  templateItemClick(index)
                }
              }}
            >
              <div
                className={
                  index === currentSelectedPage
                    ? 'canv-thumb-cont canv-thumb-cont-selected'
                    : 'canv-thumb-cont'
                }
              >
                <div
                  className='template-main-cont'
                  style={{
                    backgroundImage:
                      TemplateSettings.layoutId === 1
                        ? currentThemeData &&
                          `url(${currentThemeData.themeImage})`
                        : 'unset',
                    backgroundColor:
                      TemplateSettings.layoutId === 1
                        ? 'unset'
                        : currentThemeData.themeColors.background,
                    borderRadius: '4px',
                    pointerEvents: 'none'
                  }}
                >
                  {TemplateSettings.layoutId === 1 ? (
                    <LayoutTitle
                      layoutData={InputRows}
                      layoutType={TemplateSettings.layoutType}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === 2 ||
                    TemplateSettings.layoutId === 3 ? (
                    <LayoutHeadDesc
                      layoutData={InputRows}
                      layoutId={TemplateSettings.layoutId}
                      layoutType={TemplateSettings.layoutType}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === 4 ? (
                    <LayoutImageHeading
                      layoutData={InputRows}
                      layoutType={TemplateSettings.layoutType}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === 5 ? (
                    <LayoutVideoDesc
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === 6 ? (
                    <LayoutQA
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                      // controlsList={controlsList}
                      replayRectangles={ReplayRectangles}
                      // isFollowTheFlow={isFollowTheFlow}
                      // priorityActive={priorityActive}
                      // handleValueChange={handleComponentValueChange}
                      // getCurrentRectangleData={getCurrentRectangleData}
                      // onPriorityChange={(priorityValue) => {
                      //   setPriorityActive((priorityActive) => priorityActive + 1)
                      // }}
                    />
                  ) : TemplateSettings.layoutId === 7 ? (
                    <LayoutQ_2_A
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                      // controlsList={controlsList}
                      replayRectangles={ReplayRectangles}
                      // isFollowTheFlow={isFollowTheFlow}
                      // priorityActive={priorityActive}
                      // handleValueChange={handleComponentValueChange}
                      // getCurrentRectangleData={getCurrentRectangleData}
                      // onPriorityChange={(priorityValue) => {
                      //   setPriorityActive((priorityActive) => priorityActive + 1)
                      // }}
                    />
                  ) : TemplateSettings.layoutId === 8 ||
                    TemplateSettings.layoutId === 9 ? (
                    <LayoutQ_3_A
                      layoutData={InputRows}
                      layoutId={TemplateSettings.layoutId}
                      layoutType={TemplateSettings.layoutType}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                      // controlsList={controlsList}
                      replayRectangles={ReplayRectangles}
                      // isFollowTheFlow={isFollowTheFlow}
                      // priorityActive={priorityActive}
                      // handleValueChange={handleComponentValueChange}
                      // getCurrentRectangleData={getCurrentRectangleData}
                      // onPriorityChange={(priorityValue) => {
                      //   setPriorityActive((priorityActive) => priorityActive + 1)
                      // }}
                    />
                  ) : TemplateSettings.layoutId === 10 ||
                    TemplateSettings.layoutId === 11 ? (
                    <LayoutImageAssmnt
                      layoutData={InputRows}
                      layoutId={TemplateSettings.layoutId}
                      layoutType={TemplateSettings.layoutType}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                      // controlsList={controlsList}
                      replayRectangles={ReplayRectangles}
                      // isFollowTheFlow={isFollowTheFlow}
                      // priorityActive={priorityActive}
                      // handleValueChange={handleComponentValueChange}
                      // getCurrentRectangleData={getCurrentRectangleData}
                      // onPriorityChange={(priorityValue) => {
                      //   setPriorityActive((priorityActive) => priorityActive + 1)
                      // }}
                    />
                  ) : (
                    <div />
                  )}
                  {/* {TemplateSettings.layoutId === 1 ? (
                    <Layout_1
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === 2 ? (
                    <Layout_2
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === 7 ? (
                    <Layout_7
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : TemplateSettings.layoutId === -1 ? (
                    <Layout_10
                      layoutData={InputRows}
                      themeProperties={currentThemeData}
                      isSideMenu={true}
                    />
                  ) : (
                    <div />
                  )} */}
                </div>
                {/* <CanvasThumbnail /> */}
              </div>
              <KnovaText
                text={'Page ' + pageNumber}
                textFontSize='12px'
                textFontWeight={500}
              />
            </div>
          )
        })}
      </div>
      <div className='nav-side-button-cont'>
        <Button
          className='nav-side-button'
          hasIconOnly
          iconDescription={isOpen ? 'close' : 'Open'}
          renderIcon={isOpen ? CaretLeft : CaretRight}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          onClick={() => {
            handleClick()
          }}
        />
      </div>
    </div>
  )
}
export { TemplatesList }
